// extracted by mini-css-extract-plugin
module.exports = {"insert":"insert_insert__PS6Hm","skew":"insert_skew__8cpUD","rightInsert":"insert_rightInsert__by_PN","leftInsert":"insert_leftInsert__jrGCc"};